import React, {
  useState,
  useCallback,
} from 'react';
import {
  useDispatch,
} from 'react-redux';
import {
  toast,
} from 'react-toastify';

import {
  uiActions,
} from 'web-actions';

import {
  Icon,
  Popup,
  Button,
  Textarea,
} from 'web-components';

import {
  Flex,
  Text,
  SVG,
} from 'web-styled';

import * as S from './styled';

type Video = {
  type?: string,
  video_id?: string,
  video_url?: string,
};

type Props = {
  onSubmit: { (): void },
};

const Footer = ({ onSubmit }: Props) => {
  const [body, setBody] = useState('');
  const [video, setVideo] = useState<Video>({});
  const [attachment, setAttachment] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [attachisOpen, setAttachisOpen] = useState(false);
  const dispatch = useDispatch();

  const handleAttachVideo = useCallback(() => {
    const onAssign = (v: any) => {
      setVideo({
        video_id: v.type === 'youtube' ? null : v.id,
        video_url: v.embed_url,
        video_name: v.name,
      });
      setBody(v.name);
    };
    const onUploaded = (videos) => {
      setVideo({
        video_id: videos[0].id,
        video_name: videos[0].name,
      });
      setBody(videos[0].name);
    };

    setAttachisOpen(false);

    const assignedId = (video.video_id || video.video_url || '').split('/').pop();
    dispatch(
      uiActions.searchVideoModal({
        query: '',
        modal: {
          title: 'Attach video',
          assignedId,
          assignButton: 'Send Video',
        },
        onAssign,
        onUploaded,
      }),
    );
  }, []);

  const handleSubmit = () => {
    if (!body) {
      toast.error("The body can't be blank");
      return;
    }

    setLoading(true);

    const values = {
      body,
    };

    if (attachment) {
      values.attachment = attachment;
    }

    if (video?.video_id) {
      values.video_id = video.video_id;
    }

    if (video?.video_url) {
      values.video_url = video.video_url;
    }

    const cb = () => {
      setLoading(false);
      setBody('');
      setVideo({});
      setAttachment(null);
      setPhotoPreview(null);
    };

    onSubmit(
      values,
      {
        onSuccess: cb,
        onError: cb,
      },
    );
  };

  return (
    <S.Footer>
      <Flex
        width="100%"
        align="center"
        spacing={10}
        justify="space-between"
        onKeyDown={(e) => {
          if (e.keyCode === 13 && !e.shiftKey) {
            e.preventDefault();
            handleSubmit();
          }
        }}
      >
        <Popup
          isOpen={attachisOpen}
          trigger={(
            <Flex
              width="44px"
              height="44px"
              align="center"
              justify="center"
              clickable
            >
              <Icon
                size="18px"
                type="fas fa-paperclip"
                color="primary"
              />
            </Flex>
          )}
          place="above"
          setPopupVisible={() => setAttachisOpen(!attachisOpen)}
          handleOuterAction={() => setAttachisOpen(false)}
        >
          <S.Actions>
            <S.Action
              padding="10px"

            >
              <SVG.Photo
                width="20"
                height="20"
              />
              <Text>Photo</Text>
              <input
                name="photo"
                type="file"
                accept="image/x-png,image/gif,image/jpeg"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const file = e.target.files;
                  if (file && file[0]) {
                    setPhotoPreview(
                      URL.createObjectURL(
                        file[0],
                      ),
                    );
                    setAttachment(file[0]);
                  }
                  setAttachisOpen(false);
                }}
              />
            </S.Action>
            <S.Action onClick={handleAttachVideo}>
              <SVG.AddVideo
                width="19"
                height="19"
              />
              <Text>Video</Text>
            </S.Action>
          </S.Actions>
        </Popup>
        {video?.video_name && (
          <S.Video>
            <Text>
              {video.video_name}
            </Text>
            <Flex
              clickable
              onClick={() => {
                setVideo({});
              }}
            >
              <Icon
                type="fas fa-times"
              />
            </Flex>
          </S.Video>
        )}

        <Flex width="calc(100% - 80px)">
          <Textarea
            value={body}
            minRows={1}
            autoFocus
            placeholder="Type your message here. Use Shift+Enter to add a new line."
            disabled={isLoading}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const value = e.target.value || '';
              setBody(value);
              if (!value) {
                setVideo({});
              }
            }}
          />
        </Flex>
        <Button
          icon="fas fa-paper-plane"
          appearance="primary"
          isLoading={isLoading}
          onClick={handleSubmit}
        />
      </Flex>
      <Flex align="center" spacing={15}>
        {photoPreview && (
          <Flex
            width="60px"
            height="60px"
            margin="15px 0 0 54px"
          >
            <S.Preview
              alt="Fail to load preview"
              style={{
                backgroundImage: `url(${photoPreview})`,
              }}
            />
            <S.Remove
              onClick={() => {
                setAttachment(null);
                setPhotoPreview(null);
              }}
            >
              <Icon
                type="fas fa-times"
              />
            </S.Remove>
          </Flex>
        )}
      </Flex>
    </S.Footer>
  );
};

export default Footer;
